/* ============================================================
   FLIGHT OUTFITTERS — Homepage JS
   ATC is handled entirely by Horizon's product-form-component.
   This file handles: star icons, hotspot sync, scroll reveal.
   ============================================================ */
(function () {
  "use strict";

  var STAR_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8L12 2Z"/></svg>';

  /* ---- Render star icons ---- */
  document.querySelectorAll('.fo-stars[data-stars]').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-stars') || '5', 10);
    el.innerHTML = Array(n).fill(STAR_SVG).join('');
  });

  /* ---- Hotspot ↔ spec-row sync ---- */
  var dots = Array.prototype.slice.call(document.querySelectorAll('.fo-hs-dot'));
  var rows = Array.prototype.slice.call(document.querySelectorAll('.fo-spec-row'));

  function setActive(i) {
    dots.forEach(function (d) { d.classList.toggle('active', d.getAttribute('data-i') == i); });
    rows.forEach(function (r) { r.classList.toggle('active', r.getAttribute('data-i') == i); });
  }

  dots.concat(rows).forEach(function (el) {
    el.addEventListener('mouseenter', function () { setActive(el.getAttribute('data-i')); });
    el.addEventListener('click',      function () { setActive(el.getAttribute('data-i')); });
  });
  if (dots.length) setActive('2');

  /* ---- Reveal on scroll (IntersectionObserver) ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('fo-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.fo-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.fo-reveal').forEach(function (el) { el.classList.add('fo-in'); });
  }

  /* ---- Newsletter: show success state if Shopify rendered it ---- */
  var nlWrap = document.querySelector('.fo-newsletter-form-wrap');
  if (nlWrap && nlWrap.querySelector('.fo-nl-success[style*="display"]') === null) {
    /* Shopify renders form.posted_successfully? server-side; JS just surfaces it */
    var nlSuccess = nlWrap.querySelector('.fo-nl-success');
    if (nlSuccess && nlSuccess.textContent.trim() !== '') {
      nlWrap.setAttribute('data-success', '');
    }
  }
})();
